import { Account, ClientInfo } from 'app/lib/account/types';
import { ReduxState } from 'app/redux/types';

const selectAccount = (state: ReduxState) : Account => state.account;

export const selectClientInfo = (state: ReduxState) => (
  selectAccount(state).clientInfo
);

export const selectClientInfoData = (state: ReduxState): ClientInfo['data'] => (
  selectClientInfo(state).data
);

export const selectFreeBets = (state: ReduxState) => (
  selectAccount(state).freebets
);
